export default "__VITE_ASSET__Cot6LGCA__"